import { render, staticRenderFns } from "./Consume.vue?vue&type=template&id=6c72a65e&scoped=true"
import script from "./Consume.vue?vue&type=script&lang=js"
export * from "./Consume.vue?vue&type=script&lang=js"
import style0 from "./Consume.vue?vue&type=style&index=0&id=6c72a65e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c72a65e",
  null
  
)

export default component.exports